import { Download } from 'lucide-react';
import WaveformDisplay from './WaveformDisplay';
import { Button } from '@/components/ui/button';

interface StemTrackProps {
  name: string;
  audioUrl: string;
  onDownload: () => void;
  index: number;
}

const StemTrack = ({ name, audioUrl, onDownload, index }: StemTrackProps) => {
  return (
    <div className="animate-fade-in h-16">
      <div className="flex items-center h-full">
        <WaveformDisplay audioUrl={audioUrl} index={index} name={name} />
        <div className="flex items-center h-full">
          <Button
            variant="ghost"
            size="icon"
            onClick={onDownload}
            className="bg-transparent border border-white/15 hover:bg-white/5"
          >
            <Download className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StemTrack;